(function () {
  /**
   * 1) Prevent the theme cart drawer from opening when Rebuy is present
   */
  function disableThemeCartDrawerOpen() {
    const tags = ["cart-drawer", "cart-notification", "cart-drawer-items"];

    tags.forEach((tag) => {
      if (!customElements.get(tag)) return;

      const Ctor = customElements.get(tag);
      if (!Ctor || !Ctor.prototype) return;

      ["open", "show", "renderContents"].forEach((fn) => {
        if (typeof Ctor.prototype[fn] !== "function") return;
        if (Ctor.prototype[`__rebuy_patched_${fn}`]) return;

        const original = Ctor.prototype[fn];
        Ctor.prototype[fn] = function () {
          // If Rebuy is loaded, do nothing (prevents theme drawer)
          if (window.Rebuy) return;
          return original.apply(this, arguments);
        };

        Ctor.prototype[`__rebuy_patched_${fn}`] = true;
      });
    });
  }

  /**
   * 2) Scroll unlock safety net (fixes the missing scrollbar / no-scroll issue)
   */
  function unlockScroll() {
    const cls = ["overflow-hidden", "no-scroll", "scroll-locked", "modal-open", "lock-scroll"];

    cls.forEach((c) => {
      document.documentElement.classList.remove(c);
      document.body.classList.remove(c);
    });

    // Remove common inline locks
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.paddingRight = "";
  }

  function init() {
    disableThemeCartDrawerOpen();

    // When any close button inside Smart Cart is clicked, unlock shortly after
    document.addEventListener("click", function (e) {
      const el = e.target;
      if (!el) return;

      const isSmartCartClose =
        el.closest(".rebuy-smart-cart__close, .rebuy-cart__close, [data-rebuy-close], .rebuy-cart-close, .rebuy-close");

      if (isSmartCartClose) {
        setTimeout(unlockScroll, 50);
        setTimeout(unlockScroll, 250); // second pass for animations
      }
    });

    // If Smart Cart gets removed from DOM, also unlock
    const obs = new MutationObserver(() => {
      const smartCartExists =
        document.querySelector(".rebuy-smart-cart, .rebuy-cart, [data-rebuy-smartcart], #rebuy-smartcart");
      if (!smartCartExists) unlockScroll();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    // Helps on bfcache restores (back/forward)
    window.addEventListener("pageshow", unlockScroll);
  }

  // Run asap + after load (covers late-registered custom elements)
  init();
  window.addEventListener("load", disableThemeCartDrawerOpen);
})();
